import Header from "../components/Header";
import Hero from "../components/Hero";
import TickerMarquee from "../components/TickerMarquee";
import Manifesto from "../components/Manifesto";
import ProductSection from "../components/ProductSection";
import Research from "../components/Research";
import MoreInfo from "../components/MoreInfo";
import COASection from "../components/COASection";
import DosageCalculator from "../components/DosageCalculator";
import CartDrawer from "../components/CartDrawer";
import Footer, { WhatsAppIcon, WA_LINK } from "../components/Footer";

export default function Home() {
  const scrollToCompounds = () => document.getElementById("compounds")?.scrollIntoView({ behavior: "smooth" });

  return (
    <div className="relative bg-[#030305] min-h-screen">
      <div className="grain" />
      <Header />
      <Hero onExplore={scrollToCompounds} />
      <TickerMarquee />
      <ProductSection />
      <Research />
      <DosageCalculator />
      <COASection />
      <Manifesto />
      <MoreInfo />
      <Footer />
      <CartDrawer />
      <a
        href={WA_LINK} target="_blank" rel="noopener noreferrer"
        className="fixed bottom-6 left-6 z-[140] flex items-center gap-2 bg-[#25D366] text-black px-4 py-3 rounded-full shadow-[0_0_25px_rgba(37,211,102,0.45)] hover:shadow-[0_0_35px_rgba(37,211,102,0.7)] transition-shadow font-mono2 text-xs font-bold uppercase tracking-widest"
        data-testid="whatsapp-fab"
        title="Message @polyonpeps for availability & sourcing"
      >
        <WhatsAppIcon size={18} />
        <span className="hidden sm:inline">@polyonpeps</span>
      </a>
    </div>
  );
}
